import React, { useState, useEffect } from 'react'
import s from './styles.module.scss'
import { Link } from 'react-router-dom'
import Select from 'react-select'

interface selectObjectProps {
    value: string
    label: string
    populateValue?: string
}

interface inputFieldSelectProps {
    readonly options: Array<selectObjectProps>
    fieldName: string
    saveValue: (obj: { field: string; value: string }) => void
    populateValue?: selectObjectProps
    enhanced?: boolean
    required?: boolean
    showErrors?: boolean
}

export const InputFieldSelect = (props: inputFieldSelectProps) => {
    const {
        options,
        saveValue,
        fieldName,
        populateValue,
        enhanced = false,
        required = false,
        showErrors = false,
    } = props
    const [valueToSave, setValueToSave] = useState<selectObjectProps | undefined>(populateValue)
    const [error, setError] = useState('')

    useEffect(() => {
        if (showErrors && required && !valueToSave?.value) {
            setError('This field is required')
        } else {
            setError('')
        }
    }, [showErrors, required, valueToSave])

    const onChange = (option: selectObjectProps | null) => {
        if (option) {
            setValueToSave(option)
            setError('')
            saveValue({ field: fieldName, value: option.value })
        }
    }

    const customStyles = enhanced
        ? {
              control: (provided: any, state: any) => ({
                  ...provided,
                  borderRadius: '8px',
                  border: state.isFocused
                      ? '2px solid rgb(56, 152, 236)'
                      : error
                      ? '2px solid #ff4444'
                      : '2px solid rgb(56, 152, 236)',
                  boxShadow: state.isFocused
                      ? '0 4px 15px rgba(200, 143, 95, 0.25)'
                      : error
                      ? '0 4px 10px rgba(255, 68, 68, 0.1)'
                      : '0 4px 10px rgba(0, 0, 0, 0.05)',
                  padding: '6px 8px',
                  fontSize: '18px',
                  transition: 'all 0.3s ease',
                  backgroundColor: error ? '#fff8f8' : '#fff',
                  '&:hover': {
                      borderColor: state.isFocused ? 'rgb(56, 152, 236)' : error ? '#ff4444' : 'rgb(56, 152, 236)',
                  },
                  transform: state.isFocused ? 'translateY(-2px)' : 'none',
              }),
              option: (provided: any, state: any) => ({
                  ...provided,
                  backgroundColor: state.isSelected
                      ? 'rgb(56, 152, 236)'
                      : state.isFocused
                      ? 'rgb(56, 152, 236)'
                      : null,
                  color: state.isSelected ? 'white' : state.isFocused ? '#333' : null,
                  '&:hover': {
                      backgroundColor: state.isSelected ? 'rgb(56, 152, 236)' : '#f9f3ee',
                      color: state.isSelected ? 'white' : '#333',
                  },
              }),
              menu: (provided: any) => ({
                  ...provided,
                  borderRadius: '8px',
                  boxShadow: '0 6px 16px rgba(0, 0, 0, 0.1)',
                  zIndex: 20000,
              }),
              menuPortal: (base: any) => ({
                  ...base,
                  zIndex: 20000,
              }),
          }
        : undefined

    return (
        <>
            <Select
                className={`${s.inputSelectStyle} ${enhanced ? s.enhanced : ''}`}
                options={options}
                onChange={onChange}
                value={valueToSave}
                styles={customStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                isClearable={!required}
            />
            {error && <span className={s.notice}>{error}</span>}
        </>
    )
}
